// Dark mode preference helpers kept out of the MobX observer.
// Instruction used: debugging.instructions.md
// Instruction used: scope-discipline.instructions.md
const DARK_MODE_STORAGE_KEY = 'dark-mode'

export function readDarkModePreference() {
  try {
    return window.localStorage.getItem(DARK_MODE_STORAGE_KEY) === 'true'
  } catch (error) {
    return false
  }
}

export function persistDarkModePreference(isDarkMode) {
  document.body.classList.toggle('dark-mode', isDarkMode)
  try {
    window.localStorage.setItem(DARK_MODE_STORAGE_KEY, String(isDarkMode))
  } catch (error) {
    // Private mode and blocked storage must not prevent the portal from loading.
  }
}
